import { ThreeView } from "../View3dWebCad";
import { SiteItemOverControls } from '../controls/SiteItemOverControls';
import { itemLoader } from "./itemLoader";
import { ObjectType } from "../ObjectType";

export class AddSiteItemLoader extends itemLoader {

    private controller: SiteItemOverControls;

    constructor(itemId: string, index: string) {
        super(itemId, index);
    }

    // 移動コントローラー作成
    protected createController(object: THREE.Object3D) {
        this.controller = new SiteItemOverControls([object], ThreeView.get().wcCameras.camera.me, this.getElement());
    }

    protected removeController() {
        this.controller.dispose();
        this.controller = undefined;
    }

    protected location(e): boolean {
        const hitObj = ThreeView.get().selectManager.hitObjects(e);

        if (hitObj.length < 1) return;

        return ObjectType.isSite(hitObj[0].object);
    }

}